import { useMemo } from 'react'

import { CustomerInfo } from '../../../models/customer/Customer'

export const useGetCustomerForClient = (
  customers?: CustomerInfo[],
  clientDetails?: { employer?: string } | null,
): CustomerInfo | undefined => {
  return useMemo(() => {
    if (!customers || customers.length === 0 || !clientDetails?.employer) {
      return
    }

    return customers.find(
      (customer: CustomerInfo) => customer?.value?.toLowerCase() === clientDetails.employer?.toLowerCase(),
    )
  }, [customers, clientDetails?.employer])
}
